/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-10-08 10:11:16
 */
/* eslint-disable */
import actionTypes from '../constants/actionTypes'
import exceptionHelper from '../utils/exceptionHelper'
import fetchHelper from '../utils/fetchHelper'
import { captureFetchException } from '../utils/sentryUtils'
import {
  createQueryCustomerAuth,
  createQueryVisiteAuth
} from '../app/authPolicyHooks'

/**
 * 根据权限策略构建客户管理请求参数
 * @param {*} state - redux state
 * @param {*} data - 请求参数
 * @returns - 返回带有权限的请求参数
 */
const buildParamsWithCustomerAuthPolicy = (state: any, data: any) => {
  const group = state.group
  const userID = state.main.user?.user_id
  const customerViewAuthPolicy = createQueryCustomerAuth(group, userID) //客户管理， source:4
  const params = JSON.parse(JSON.stringify(data))
  if (params.filter) {
    const { departmentIDList, userIDList } = params.filter
    if (
      (!departmentIDList || departmentIDList.length === 0) &&
      (!userIDList || userIDList.length === 0)
    ) {
      params.filter.departmentIDList =
        customerViewAuthPolicy?.departmentIDList?.map((item) => Number(item)) ||
        []
      params.filter.userIDList = customerViewAuthPolicy?.userIDList || []
    }
  } else {
    const { departmentIDList, userIDList } = params
    if (
      (!departmentIDList || departmentIDList.length === 0) &&
      (!userIDList || userIDList.length === 0)
    ) {
      params.departmentIDList =
        customerViewAuthPolicy?.departmentIDList?.map((item) => Number(item)) ||
        []
      params.userIDList = customerViewAuthPolicy?.userIDList || []
    }
  }
  return params
}

const buildParamsWithVisiteAuthPolicy = (state: any, data: any) => {
  const group = state.group
  const userID = state.main.user?.user_id
  const visiteViewAuthPolicy = createQueryVisiteAuth(group, userID) //拜访记录， source:5
  const params = JSON.parse(JSON.stringify(data))
  if (params.filter) {
    const { departmentIDList, userIDList } = params.filter
    if (
      (!departmentIDList || departmentIDList.length === 0) &&
      (!userIDList || userIDList.length === 0)
    ) {
      params.filter.departmentIDList =
        visiteViewAuthPolicy?.departmentIDList?.map((item) => Number(item)) || []
      params.filter.userIDList = visiteViewAuthPolicy?.userIDList || []
    }
  } else {
    const { departmentIDList, userIDList } = params
    if (
      (!departmentIDList || departmentIDList.length === 0) &&
      (!userIDList || userIDList.length === 0)
    ) {
      params.departmentIDList =
        visiteViewAuthPolicy?.departmentIDList?.map((item) => Number(item)) || []
      params.userIDList = visiteViewAuthPolicy?.userIDList || []
    }
  }

  return params
}

// 客户拜访记录
export function fetchVisitRecords(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/location/excel/query',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithVisiteAuthPolicy(getState(), data)) //接入权限中心
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 下载拜访记录
export function downloadVisitRecords(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    const params = buildParamsWithVisiteAuthPolicy(getState(), data) //接入权限中心
    params.departmentIDList = params.departmentIDList.map((item) =>
      String(item)
    )
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/location/excel/download',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 拜访记录下载历史
export function fetchVisitRecordsDownloadHistory(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/location/excel/history',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 获取客户列表
export function fetchCustomerList(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/location/list',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          buildParamsWithCustomerAuthPolicy(getState(), data)
        ) //接入权限中心
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 批量查询地点对应的gps坐标
export function fetchLocationsByAddress(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/location/excel/gps',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function importCustomers(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/location/excel/import',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 下载客户信息
export function downloadCustomers(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/info/excel/download',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          buildParamsWithCustomerAuthPolicy(getState(), data)
        ) //接入权限中心
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 批量删除客户信息
export function deleteCustomers(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/delete/batch',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          buildParamsWithCustomerAuthPolicy(getState(), data)
        ) //接入权限中心
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// 客户下载历史
export function fetchCustomersDownloadHistory(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/group/customer/info/excel/history',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}
